import { useAccount } from '@lib/context/account-context'
import React from 'react'

type Props = {
  noAuthFallback?: React.ReactNode
  pendingApprovalFallback?: React.ReactNode
  children: React.ReactNode
  approvalRequired?: boolean
}

/** Only render children if customer is logged in. Optionally
 * render a fallback if customer if not logged in, or if customer
 * account is not approved by Barnhill yet. */
export default function BHRequireAccount({
  noAuthFallback,
  pendingApprovalFallback,
  children,
  approvalRequired = true,
}: Props) {
  const { customer, isApproved, isSetUp, productVisibilityGroups } =
    useAccount()

  if (!customer || (approvalRequired && !isApproved) || !isSetUp) {
    if (!customer) {
      return <>{noAuthFallback}</>
    }

    if (approvalRequired && !isApproved) {
      return <>{pendingApprovalFallback}</>
    }
  }

  return <>{children}</>
}

export const withAccount = <P extends object>(
  Component: React.ComponentType<P>
) => {
  return class WithAccount extends React.Component<P> {
    render() {
      return (
        <BHRequireAccount>
          <Component {...(this.props as P)} />
        </BHRequireAccount>
      )
    }
  }
}
